import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router';
import ReactGA from 'react-ga';
import firebase from 'firebase';

import store, { history } from './store';
import './bundle.styl';
import '../../medua-components/dist/index.css';
import './i18n';

import App from './containers/app';
import Welcome from './containers/welcome';

import Login from './routes/auth/login';
import ResetPassword from './routes/auth/reset-password';

import School from './routes/school';
import SchoolDescription from './routes/school/description';

import Courses from './routes/courses';
import CoursesCourse from './routes/courses/course';
import CoursesClassesClass from './routes/courses/classes';

import Users from './routes/users';

import Account from './routes/account';
import AccountSettings from './routes/account/settings';
import AccountSettingsDevices from './routes/account/settings/devices';
import AccountSettingsLanguage from './routes/account/settings/language';
import AccountEdit from './routes/account/edit';
import SchoolEdit from './routes/account/school';
import AccountPassword from './routes/account/password';
import AccountBilling from './routes/account/billing';
import AccountBillingPayment from './routes/account/billing/payment';
import AccountBillingHistory from './routes/account/billing/history';
import AccountStorage from './routes/account/storage';
import AccountLegal from './routes/account/legal';
import AccountLegalLicense from './routes/account/legal/license';
import AccountLegalTOS from './routes/account/legal/tos';
import AccountPrivacy from './routes/account/privacy';
import AccountHelp from './routes/account/help';

// Google Analytics initializacion
ReactGA.initialize('UA-93828215-4', {
  debug: false,
  titleCase: false,
  gaOptions: {},
});

/* eslint-disable no-undef */
function logPageView() {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.set({ page: window.location.href });
    ReactGA.pageview(window.location.href);
  }
}

/* eslint-disable no-console */
/* eslint-disable */
function requireAuth() {
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      user.getToken().then((data) => {
        console.log(data)
      })
    // } else if (!user.emailVerified) {
    //   history.push('/confirm-email');
    // } else if (!user.displayName) {
    //   history.push('/setup');
  } else {
    history.push('/login');
  }
  });
}

function alreadyLoggedIn() {
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      history.push('/');
    }
  });
}

// function requireAuth(nextState, replace) {
//   const key = Object.keys(localStorage).find(e => e.match(/firebase:authUser/));
//   const data = JSON.parse(localStorage.getItem(key));
//   if (data == null) {
//       replace({
//           pathname: '/login',
//           state: {
//               nextPathname: nextState.location.pathname,
//           },
//       });
//   }
// }

// Router initialization
ReactDOM.render(
  <Provider store={store}>
    <Router
      onUpdate={() => {
        window.scrollTo(0, 0);
        logPageView();
      }} history={history}
    >
      <Route component={Welcome} >
        <Route path="login" component={Login} onEnter={alreadyLoggedIn} />
        <Route path="reset-password" component={ResetPassword} onEnter={alreadyLoggedIn} />
      </Route>
      <Route component={App} onEnter={requireAuth}>
        <Route exact path="/" components={{ master: School }} />
        <Route path="courses" components={{ master: Courses }} />
        <Route path="courses/:slug" components={{ master: Courses, detail: CoursesCourse}} />
        <Route path="courses/:slug/classes/:class" components={{ master: Courses, detail: CoursesClassesClass}} />

        <Route path="users" components={{ master: Users }} />
        <Route path="users/:slug" components={{ master: Users }} />

        <Route path="school" components={{ master: School, detail: SchoolDescription }} />

        <Route path="account" components={{ master: Account }} />
        <Route path="account/settings" components={{ master: Account, detail: AccountSettings }} />
        <Route path="account/settings/devices" components={{ master: Account, detail: AccountSettingsDevices }} />
        <Route path="account/settings/language" components={{ master: Account, detail: AccountSettingsLanguage }} />
        <Route path="account/edit" components={{ master: Account, detail: AccountEdit }} />
        <Route path="account/school" components={{ master: Account, detail: SchoolEdit }} />
        <Route path="account/password" components={{ master: Account, detail: AccountPassword }} />
        <Route path="account/billing" components={{ master: Account, detail: AccountBilling }} />
        <Route path="account/billing/payment" components={{ master: Account, detail: AccountBillingPayment }} />
        <Route path="account/billing/history" components={{ master: Account, detail: AccountBillingHistory }} />
        <Route path="account/storage" components={{ master: Account, detail: AccountStorage }} />
        <Route path="account/legal" components={{ master: Account, detail: AccountLegal }} />
        <Route path="account/legal/license" components={{ master: Account, detail: AccountLegalLicense }} />
        <Route path="account/legal/tos" components={{ master: Account, detail: AccountLegalTOS }} />
        <Route path="account/privacy" components={{ master: Account, detail: AccountPrivacy }} />
        <Route path="account/help" components={{ master: Account, detail: AccountHelp }} />

      </Route>
    </Router>
  </Provider>, document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/index.jsx